import { Button } from "../../core/Button";

import { TSecundaryButtonProps } from "./SecundaryButton.type";

export default function SecundaryButton({
  text,
  type,
  onClick,
  styles,
}: TSecundaryButtonProps) {
  return (
    <Button
      type={type}
      text={text}
      onClick={onClick}
      className={styles} />
  );
}
